module.exports = __webpack_public_path__ + "static/media/preview_screen7.455a933b.png";